
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
//import * as rg4js from 'raygun4js';

export class VersionService {

    private localStorageKey = "valkyrieVersion";

    private firstCheck = true;

    static $inject = ["$rootScope", "$http", "$interval", "$window", "$mdDialog", "translationService"];

    constructor(
        private readonly $rootScope: angular.IRootScopeService,
        private readonly $http: angular.IHttpService,
        private readonly $interval: angular.IIntervalService,
        private readonly $window: angular.IWindowService,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly translationService: TranslationService) {

        this.startVersionMonitoring();
    }

    getAPIVersion(): angular.IPromise<string> {
        //console.warn("getAPIVersion");

        return this
            .$http({
                url: "/api/version",
                method: "GET",
                cache: true,
                params: { minsToLive: 5 * 60 }
            })
            .then((response: angular.IHttpPromiseCallbackArg<string>) => {
                var previousVersion = this.getCachedAPIVersion();

                localStorage.setItem(this.localStorageKey, response.data);
                //rg4js('setVersion', response.data);

                if (previousVersion != null && previousVersion !== response.data) {
                    this.showVersionUpdatedNotification(response.data, previousVersion);
                }

                this.firstCheck = false;

                return response.data;
            });
    }

    getCachedAPIVersion() {
        return localStorage.getItem(this.localStorageKey);
    }

    // ---

    private startVersionMonitoring() {
        // Changed from 5min to 60min by CJE 27th June
        this.$interval(() => {
            this.getAPIVersion();
        }, 15 * 60 * 1000);
    }

    private showVersionUpdatedNotification(newVersion: string, previousVersion: string) {
        console.warn(`New version detected, gone from ${previousVersion} to ${newVersion}`);

        if (this.firstCheck) {
            this.$window.location.reload(true);
            return;
        }

        this.$rootScope.$broadcast("versionUpdated", newVersion, previousVersion);
    }
}
